var exports = {
  "_": "labelContainer__wErxbY",
  "R": "labelLink__7R1beB",
};

module.exports = exports;
